export enum CheckoutErrorStatus {
  CommericalAddress = 'COMMERCIAL_ADDRESS',
  ExpiredOffer = 'EXPIRED_OFFER_ERROR',
  ExpiredRenewal = 'EXPIRED_RENEW_ERROR',
  Ineligible = 'INELIGIBLE',
  InvalidCustomer = 'USER_NOT_ALLOWED_TAKE_OFFER',
  InvalidCustomerData = 'INVALID_CUSTOMER_DATA_ERROR',
  InvalidOfferReference = 'INVALID_REFERENCE',
  InvalidOfferRenewalStatus = 'INVALID_STATUS',
  InvalidPayment = 'INVALID_PAYMENT_DETAILS',
  InvalidPaymentData = 'INVALID_PAYMENT_DATA_ERROR',
  NoOffers = 'NO_OFFERS',
  NoPlanSchemeFound = 'PLAN_OFFER_NOT_FOUND',
  PlanLapsed = 'PLAN_LAPSED',
  PlanSkipped = 'PLAN_SKIPPED',
  PostCodeMatch = 'POSTAL_CODE_MATCH_ERROR',
  SalesforceInternalService = 'SALESFORCE_INTERNAL_SERVICE_ERROR',
  WeightLimitExceeded = 'WEIGHT_LIMIT_EXCEEDED',
}
